import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";

const axios = require("axios").default;

function PreviewSet() {
  let params = useParams();
  const [error, setError] = useState("");
  const [noCardError, setNoCardError] = useState(false);
  const [setData, setSetData] = useState([]);
  const [FCAmount, setFCAmount] = useState(0);
  const [nameCap, setNameCap] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");

    axios
      .post(
        `https://application-flashcards.herokuapp.com/api/sets/${params.setname}`,
        {
          token,
        }
      )
      .then(function (response) {
        if (response.data.length === 0) {
          setError("Set doesn't exist");
        } else {
          setSetData(response.data[0]);
          setFCAmount(response.data[0].flashcards.length);
          setNameCap(
            response.data[0].setName.charAt(0).toUpperCase() +
              response.data[0].setName.slice(1)
          );
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }, []);

  return (
    <>
      {error ? (
        <p>{error}</p>
      ) : (
        <>
          {noCardError ? (
            <div className="bg-amber-50 text-slate-200 py-2 px-32 sm:px-10 lg:flex lg:justify-center lg:px-0">
              <p className="text-md font-normal my-2 text-amber-600">
                <span className="text-lg font-extrabold pr-2">! </span>
                This set has no flashcards. Add flashcards to this set to begin
                test.
              </p>
            </div>
          ) : null}
          <div className="rounded-lg border-solid border border-slate-300 my-2 w-4/12 shadow-xl p-5 mx-auto mt-24 md:w-10/12 md:my-8 lg:w-8/12">
            <h2 className="font-semibold text-3xl my-1">{nameCap}</h2>
            <div className="flex justify-between my-2">
              <p>Highest Score:</p>
              <p>{setData.highScore}</p>
            </div>
            <div className="flex justify-between my-2">
              <p>Number Of Questions:</p>
              <p>{FCAmount ? FCAmount : 0}</p>
            </div>
            <div className="flex justify-between my-2">
              <p>Recent Score:</p>
              <p>{setData.mostRecentScore}</p>
            </div>
            <div className="flex justify-between my-2">
              <p>Highest Percent:</p>
              <p>
                {setData.highScore ? (setData.highScore / FCAmount) * 100 : 0}%
              </p>
            </div>
            <div>
              <button
                className="w-full text-white border-solid border border-neutral-50 rounded p-1 my-1 bg-green-400 hover:bg-green-500"
                onClick={() => {
                  if (FCAmount === 0) {
                    setNoCardError(true);
                  } else {
                    navigate(`/dashboard/set/test/${params.setname}`, {
                      state: {
                        nameCap: nameCap,
                      },
                    });
                  }
                }}
              >
                Start Test
              </button>
            </div>
            <div>
              <button
                className="w-6/12 text-white bg-amber-400 border-solid border border-neutral-50 rounded p-1 hover:bg-amber-500"
                onClick={() => {
                  navigate(`/dashboard/set/${params.setname}`);
                }}
              >
                Edit Set
              </button>
              <button
                className="w-6/12 text-white bg-red-500 border-solid border border-neutral-50 rounded p-1 hover:bg-red-600"
                onClick={() => {
                  navigate(`/dashboard/deleteset/${setData.id}`, {
                    state: {
                      setName: setData.setName,
                      nameCap: nameCap,
                    },
                  });
                }}
              >
                Delete Set
              </button>
            </div>
            {/* <button
            onClick={() => {
              navigate("/dashboard");
            }}
          >
            Back
          </button> */}
          </div>
        </>
      )}
    </>
  );
}

export default PreviewSet;
